module.exports = __webpack_public_path__ + "img/save-long@2x.bc51f5bd.png";